var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"main-container",class:{
  'main-container__block-style': _vm.isBlockStyle,
  'main-container__isTabs': _vm.isTabs
}},[(_vm.loading)?_c('div',{staticClass:"main-container__loading"},[_c('a-icon',{staticClass:"main-container__loading__icon",attrs:{"type":"loading"}})],1):(!_vm.loading && (_vm.permissionOfSection && !_vm.checkPermissions(_vm.user.permissions, _vm.permissionOfSection, 'view')))?_c('div',{staticClass:"main-container__no-access"},[_vm._v(" You do not have access to this section ")]):_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }